import axios from './axiosplugin';
import options from './isLocalDev';
import Cookies from './cookies';
//  console.log('有点意思啊!!!!!!!!!!!!:', Authorization);
//  console.error('每次请求添加', axios.defaults.headers);
export default class Fetch {
  request(config) {
    if (/http(s)?/.test(config.url)) {
      options.baseURL = "";
    }
    //  let Authorization = Cookies.getCookie("Authorization");
    //  Authorization = unescape(Authorization);
    //  if (Authorization != "") {
    //    //  = Authorization;
    //    // Authorization
    //    axios.defaults.headers.common['Authorization'] = Authorization;
    //  }
    //  console.log('有点意思???', options, config);
    //  console.log('输出当前methods');
    return new Promise((resolve, reject) => {
      axios({
        url: options.baseURL + config.url,
        method: config.method,
        data: {
          ...config.data,
          // "_t": +new Date
        },

        params: (/post/i).test(config.method) ? {
          ...config.params,
        } : {
            ...config.params,
            "_t": +new Date
          },
        //  _t: +new Date
      }).then((res) => {
        resolve({
          ...res.data
        })
      }).catch((err) => {
        reject(err)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/requestHttp.js